import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import {openModal, closeModal} from 'Skelet/src/modules/functions.js'
import Labels from 'Skelet/src/components/Labels.js'
import ModalUpdateContact from './ModalUpdateContact.js'
import ModalAddLabel from './ModalAddLabel.js'
import refresh_icon from './28406.svg';
import arrow_icon from './arrow.svg';


class Pipeline extends React.Component {

  constructor(props) {
    super(props);
    let pipeline_name = window.location.pathname;
    pipeline_name = decodeURI(pipeline_name.split('/').pop());
    this.state = {page:0, pipeline_name, modal_update_open:false, modal_content:{}, modal_label_open:false};

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "pipeline_list", "GET", config.api_url+"/pipeline-list?t="+this.props.session_token, undefined, {"PM-List-Page":this.state.page});
      this.props.fetchDataIfReady(config.api_token, "contact_list", "GET", config.api_url+"/contact-list?t="+this.props.session_token, undefined, {"PM-List-Page":this.state.page});
      this.props.fetchDataIfReady(config.api_token, "label_list", "GET", config.api_url+"/label-list?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "pipeline_list", "GET", config.api_url+"/pipeline-list?t="+nextProps.session_token);
      this.props.fetchDataIfUndefined(config.api_token, "contact_list", "GET", config.api_url+"/contact-list?t="+nextProps.session_token);
      this.props.fetchDataIfUndefined(config.api_token, "label_list", "GET", config.api_url+"/label-list?t="+nextProps.session_token);
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleScroll(e) {
    let window_bottom = window.pageYOffset + window.innerHeight;
    let list_bottom = this.wrapperRef.offsetTop + this.wrapperRef.scrollHeight;
    if (window_bottom >= list_bottom) {
      let page_cards = this.props.apiData["contact_list"];
      if(page_cards !== undefined && !page_cards.isFetching && !page_cards.limitReached) {
        let new_page = (this.state.page+1);
        this.setState({page:new_page});
        this.props.fetchDataIfReady(config.api_token, "contact_list", "GET", config.api_url+"/contact-list?t="+this.props.session_token, undefined, {"PM-List-Page":new_page}, false, true);
      }
    }
  }

  render() {
    let card = null, card_header = null, end_of_list_text = "", page_cards = this.props.apiData["contact_list"], label_list = this.props.apiData["label_list"], pipeline_list = this.props.apiData["pipeline_list"];
    if(page_cards !== undefined && label_list !== undefined && pipeline_list !== undefined) {
      let pipeline_labels = null;
      pipeline_list.data.map(function(item, i) {
        if(item.name === this.state.pipeline_name) pipeline_labels = item.labels;
      }.bind(this));
        if(pipeline_labels !== null) {
          let pipeline_labels_array = pipeline_labels.split(";;");
          let divided = {};
          for (let i = 0; i < pipeline_labels_array.length; i++) {
            divided[pipeline_labels_array[i]] = false;
          }

          let all_cards = [];
          for (let i = 0; i < pipeline_labels_array.length; i++) {
            let label = pipeline_labels_array[i];
            let first_divider = true;
            let cards = page_cards.data.map(function(item, i) {
              let divider = "";
              let label_display = <Labels label_list={label_list} item_labels={label} displayMode />;

              let item_labels_array = [];
              if(item.labels) {
                item_labels_array = item.labels.split(";;");
                item_labels_array = item_labels_array.map(function(label) {
                  return label.split(",")[0];
                });
              }
              let last_match = null;
              for (let i2 = 0; i2 < pipeline_labels_array.length; i2++) {
                if(item_labels_array.includes(pipeline_labels_array[i2])) {
                  last_match = pipeline_labels_array[i2];
                }
              }

              if(label === last_match) {
                let contact_ids = [];
                for (let i5 = 0; i5 < page_cards.data.length; i5++) {
                  let this_contact_labels = [];
                  if(page_cards.data[i5].labels) {
                    this_contact_labels = page_cards.data[i5].labels.split(";;");
                    this_contact_labels = this_contact_labels.map(function(label) {
                      return label.split(",")[0];
                    });
                  }
                  if(this_contact_labels.includes(label)) {
                    let contact_labels_array = [];
                    if(page_cards.data[i5].labels) {
                      contact_labels_array = page_cards.data[i5].labels.split(";;");
                      contact_labels_array = contact_labels_array.map(function(label) {
                        return label.split(",")[0];
                      });
                    }
                    let contact_last_match = false;
                    for (let i6 = 0; i6 < pipeline_labels_array.length; i6++) {
                      if(contact_labels_array.includes(pipeline_labels_array[i6])) {
                        contact_last_match = pipeline_labels_array[i6];
                      }
                    }
                    if(label === contact_last_match) contact_ids.push(page_cards.data[i5].id);
                  }
                }
                let upd_data = {contact_ids:contact_ids.join(";;"), labels:null};
                if(divided[label] === false) {
                  divided[label] = 1;
                  divider = <div style={{padding:"15px"}}>{label_display}<button className="btn" style={{marginLeft:"10px"}} onClick={(e) => openModal(this, e, upd_data, "modal_label_open")}>add label</button></div>;
                  if(first_divider) {
                    first_divider = false;
                  }
                } else {
                  divided[label] += 1;
                }
                let label_background = "#000";
                for (let i3 = 0; i3 < label_list.data.length; i3++) {
                  let this_label = label_list.data[i3];
                  if(this_label.id === parseInt(label, 10)) {
                    label_background = "#"+this_label.background;
                  }
                }
                let filtered_labels = "";
                if(item.labels !== null) {
                  /*let item_labels_arr = item.labels.split(";;");
                  let item_labels = item_labels_arr.map(function(label) {
                    return label.split(",")[0];
                  }).join(';;');
                  let found = item_labels.indexOf(label);
                  if(found === 0 && label.length === item_labels.length) {
                    //only item
                  } else if(found === 0) {
                    //first item
                    filtered_labels = item_labels.substring(label.length+2); // +2 for ;;
                  } else if(found+label.length === item_labels.length) {
                    //last item
                    filtered_labels = item_labels.substring(0, item_labels.length-label.length-2); // -2 for ;;
                  } else {
                    //item in middle
                    filtered_labels = item_labels.substring(0, found);
                    filtered_labels += item_labels.substring(found+label.length+2); // +2 for ;;
                  }*/
                  filtered_labels = item.labels;
                }
                return <div key={"1k"+i}>{divider}<div className="contact" style={{borderLeftColor:label_background}} onClick={(e) => openModal(this, e, item, "modal_update_open")}>
                  <div className="contact-name">{item.name}</div>
                  <Labels label_list={label_list} item_labels={filtered_labels} displayMode />
                </div></div>;  
              } else {
                return null;
              }
              
            }.bind(this));
            all_cards.push(cards);
            all_cards.push(<div key={"whitespace"+i}>&nbsp;</div>);
          }
          let headers = [];
          let count_divided = 0;
          for (const [key, value] of Object.entries(divided)) {
            for (let i4 = 0; i4 < label_list.data.length; i4++) {
              let this_label = label_list.data[i4];
              if(this_label.id === parseInt(key, 10)) {
                let display_value = value ? value : 0;
                headers.push(<span key={"i_"+i4+"_"+key} className="contact-label" style={{background:"#"+this_label.background, color:"#"+this_label.color, minWidth:"140px"}}><span style={{fontSize:"40px",fontWeight:"bold",display:"block"}}>{display_value}</span><span style={{fontSize:"20px"}}>{this_label.name}</span></span>);
              }
            }
            count_divided++;
            if(count_divided !== Object.entries(divided).length) {
              headers.push(<span key={"a_"+count_divided+"_"+key} style={{marginRight:"3px"}}><img src={arrow_icon} alt=">" style={{marginTop:"-68px"}}/></span>);
            }
          }
          card_header = <div className="card">{headers}</div>;
          card = <div className="card contacts">{all_cards}</div>;
        }
    }

    if(page_cards === undefined || page_cards.isFetching) {
      end_of_list_text = "Loading..";
    } else if((page_cards !== undefined && !page_cards.isFetching && page_cards.limitReached)) {
      if(page_cards.data[0] !== undefined) {
        end_of_list_text = "";
      } else {
        end_of_list_text = "No contacts.";
      }
    }

    return (
      <div className="container content" ref={(node) => this.setWrapperRef(node)}>
        <div className="card-layout">
          <div className="card-layout-div50"><strong>{this.state.pipeline_name}</strong></div>
          <div className="card-layout-div50 refresher"><img src={refresh_icon} alt="Refresh" onClick={() => this.refresh()}/></div>
        </div>
        {card_header}
        {card}
        <div className="end_of_list_text">{end_of_list_text}</div>
        
        <ModalUpdateContact shouldShow={this.state.modal_update_open} close={() => closeModal(this, "modal_update_open")} update_data={this.state.modal_content} label_list={this.props.apiData["label_list"]} />
        <ModalAddLabel shouldShow={this.state.modal_label_open} close={() => closeModal(this, "modal_label_open")} update_data={this.state.modal_content} label_list={this.props.apiData["label_list"]} />
      </div>
    );
  }

  refresh() {
    this.props.clearStateBlock("pipeline_list");
    this.props.clearStateBlock("contact_list");
    this.props.clearStateBlock("label_list");
    this.setState({"page":0});  
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Pipeline)



// WEBPACK FOOTER //
// ./src/containers/Pipeline.js